import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { IRelatedNewsItem } from '@shared/constants/models.const';
import { AddFrPipe } from '@shared/pipes/add-fr.pipe';
import { E_CONTENT_TYPE, E_DATE_FORMAT, E_LINK_TYPE } from '@shared/constants/enums.const';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../services/helper.service';
import { SeeAllComponent } from '@shared/components/see-all/see-all.component';

@Component({
  selector: 'app-links-section',
  imports: [
    AddFrPipe,
    TranslateModule,
    SeeAllComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './links-section.component.html',
  styleUrl: './links-section.component.scss',
})
export class LinksSectionComponent {
  title = input.required<string>();
  showSeeAllButton = input<boolean>(false);
  seeAllButtonTitle = input<string>('See all related');
  links = input<IRelatedNewsItem[]>([]);
  isQuickLinks = input<boolean>(false);
  useStartDate = input<boolean>(false);
  isDateShown = input<boolean>(false);

  relatedId = input<number>();
  contentType = input<E_CONTENT_TYPE>();

  seeAllClicked = output<void>();
  protected readonly E_LINK_TYPE = E_LINK_TYPE;
  protected readonly ButtonTypes = BUTTON_TYPES;
  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;

  clicked() {
    this.seeAllClicked.emit();
  }

  constructor(public HELPER: HelperService) {}
}
